import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { COMPANY, LOGO_NAV } from "../data/content";

export function Footer() {
  const { t, lang } = useLang();
  const cols = [
    { title: "TPU", links: [["/tpu", lang === "de" ? "TPU Übersicht" : "TPU overview"], ["/tpu/spritzguss", lang === "de" ? "TPU Spritzguss" : "TPU Injection Molding"], ["/tpu/extrusion", "TPU Extrusion"], ["/tpu#shore", lang === "de" ? "Shore-Härte" : "Shore hardness"]] },
    { title: t("nav.products"), links: [["/produkte", t("nav.products")], ["/andere-kunststoffe", lang === "de" ? "Andere Kunststoffe" : "Other plastics"], ["/anwendungen", t("nav.applications")], ["/branchen", t("nav.industries")]] },
    { title: t("nav.about"), links: [["/qualitaet", t("nav.quality")], ["/logistik", t("nav.logistics")], ["/wissen", t("nav.knowledge")], ["/ueber-uns", t("nav.about")]] },
  ];
  return (
    <footer className="border-t border-[#e4e9f0] bg-[#16181D] text-white">
      <div className="pn-container grid grid-cols-2 gap-10 py-16 md:grid-cols-5">
        <div className="col-span-2">
          <span className="inline-flex rounded-xl bg-white px-3.5 py-2.5 shadow-sm">
            <img src={LOGO_NAV} alt="PlastoNord GmbH Logo" className="h-8 w-auto object-contain" height="32" />
          </span>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/60">
            {lang === "de"
              ? "Technische Kunststoff-Rohstoffe mit Spezialisierung auf TPU – für Extrusion, Spritzguss und industrielle Anwendungen. Made in Germany."
              : "Technical plastic raw materials specialised in TPU – for extrusion, injection molding and industrial applications. Made in Germany."}
          </p>
          <div className="mt-6 space-y-2 text-sm text-white/70">
            <a href={`tel:${COMPANY.phoneRaw}`} className="flex items-center gap-2 hover:text-[#E2611C]"><Phone size={15} /> {COMPANY.phone}</a>
            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 hover:text-[#E2611C]"><Mail size={15} /> {COMPANY.email}</a>
            <span className="flex items-start gap-2"><MapPin size={15} className="mt-0.5" /> {COMPANY.street}, {COMPANY.zip} {COMPANY.city}</span>
          </div>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <h4 className="font-head text-sm font-semibold uppercase tracking-wider text-white/90">{c.title}</h4>
            <ul className="mt-4 space-y-2.5">
              {c.links.map(([to, label]) => (
                <li key={label}><Link to={to} className="text-sm text-white/60 transition-colors hover:text-[#E2611C]">{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="pn-container flex flex-col items-start justify-between gap-3 py-6 text-xs text-white/50 md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} {COMPANY.name} · {COMPANY.region}</p>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            <Link to="/impressum" className="hover:text-white" data-testid="footer-impressum">{lang === "de" ? "Impressum" : "Imprint"}</Link>
            <Link to="/datenschutz" className="hover:text-white" data-testid="footer-datenschutz">{lang === "de" ? "Datenschutz" : "Privacy"}</Link>
            <Link to="/agb" className="hover:text-white" data-testid="footer-agb">{lang === "de" ? "AGB" : "Terms"}</Link>
            <Link to="/kontakt" className="hover:text-white">{t("nav.contact")}</Link>
            <a href={COMPANY.portalUrl} className="flex items-center gap-1 hover:text-white">{t("nav.portal")} <ArrowUpRight size={12} /></a>
          </div>
        </div>
      </div>
    </footer>
  );
}
